/**
 * Figma `216:8023`. Rendered when `useOrgContext()` resolves `not-yours` --
 * the URL names a tenant or campaign absent from `/control/me`'s
 * `organisations`, reached only by a URL or a shared link, never by a click
 * inside the application (platform design §17.2). No sidebar, no nav: there
 * is no organisation here to build either one from.
 *
 * The frame names no organisation administrator, unlike §17.15's own
 * missing-capability state for a real member lacking one grant -- there is
 * nothing here to name one from. `/control/me` never told this client who
 * administers an organisation it holds no membership in, and the frame
 * agrees: its copy sends the reader home, not to a person.
 */

import type { ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import { Activity, ArrowLeft } from 'lucide-react';

import { HOME_PATH } from '../../routes/paths';
import { Button } from '../../../ui/button';
import { Card, CardContent } from '../../../ui/card';
import { sw } from './messages';

export function NotYourOrganisation(): ReactNode {
  return (
    <main className="flex min-h-svh items-center justify-center p-8">
      <Card className="w-full max-w-sm">
        <CardContent className="flex flex-col items-center gap-4 text-center">
          <div className="bg-primary-quiet flex size-10 items-center justify-center rounded-lg">
            <Activity aria-hidden className="size-6" />
          </div>
          <h1 className="text-title-lg">{sw('notYours.title')}</h1>
          <p className="text-muted-foreground text-lede">{sw('notYours.body')}</p>
          <Button asChild>
            <Link to={HOME_PATH}>
              <ArrowLeft aria-hidden />
              {sw('notYours.action')}
            </Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
